import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const TabsTheme = {
    tabs: {
        light: {
            color: withOpacity(Colors.black, Opacities.medium),
            activeColor: Colors.black,
            disabledColor: withOpacity(Colors.black, Opacities.xLow),
            borderColor: Colors.greyWhite,
            borderColorSelected: Colors.accessibleSafetyOrange,
            monochrome: {
                color: withOpacity(Colors.black, Opacities.medium),
                activeColor: Colors.black,
                disabledColor: withOpacity(Colors.black, Opacities.xLow),
                borderColor: Colors.greyWhite,
                borderColorSelected: Colors.black,
            },
        },
        dark: {
            color: withOpacity(Colors.white, Opacities.medium),
            activeColor: Colors.white,
            disabledColor: withOpacity(Colors.white, Opacities.xLow),
            borderColor: withOpacity(Colors.white, Opacities.xLow),
            borderColorSelected: Colors.accessibleSafetyOrange,
            monochrome: {
                color: withOpacity(Colors.white, Opacities.medium),
                activeColor: Colors.white,
                disabledColor: withOpacity(Colors.white, Opacities.xLow),
                borderColor: withOpacity(Colors.white, Opacities.xLow),
                borderColorSelected: Colors.white,
            },
        },
    },
};
export default TabsTheme;
